webpackJsonp([33],{

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(629);


var Index = function Index() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 668));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 646));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 647));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 645));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 637));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 643));
};
var test = function test() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 644));
};
var Cart = function Cart() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 639));
};
var order = function order() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 648));
};
var user = function user() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 667));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 663));
};
var collectList = function collectList() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 659));
};
var information = function information() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 661));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 658));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 660));
};
var support = function support() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 665));
};
var paidMbr = function paidMbr() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 664));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 640));
};
var rxcheckout = function rxcheckout() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 641));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 649));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 654));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 653));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 652));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 662));
};
var supportDetail = function supportDetail() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 666));
};
var article = function article() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 638));
};
var custompage = function custompage() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 642));
};
var promotion = function promotion() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 651));
};
var preferential = function preferential() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 650));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home', component: Home }, { path: 'goods', component: GoodS }, { path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails }, { path: 'test', name: 'test', component: test }, { path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods }]
  }, { path: '/login', name: 'login', component: Login }, { path: '/register', name: 'register', component: Register }, { path: '/cart', name: 'cart', component: Cart }, { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch }, {
    path: '/order',
    name: 'order',
    component: order,
    children: [{ path: 'payment', name: 'payment', component: payment }, { path: '/search', name: 'search', component: Search }]
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{ path: 'orderList', name: '我的订单', component: orderList }, { path: 'rxOrderList', name: '我的预约单', component: orderList }, { path: 'collectList', name: '我的收藏', component: collectList }, { path: 'orderDetail', name: '订单详情', component: orderDetail }, { path: 'information', name: '会员信息', component: information }, { path: 'addressList', name: '收货地址', component: addressList }, { path: 'coupon', name: '我的优惠', component: coupon }, { path: 'support', name: '售后服务', component: support }, { path: 'supportDetail', name: '售后详情', component: supportDetail }, { path: 'paidMbr', name: '付费会员', component: paidMbr }]
  }, { path: '/checkout', name: 'checkout', component: checkout }, { path: '/rxcheckout', name: 'rxcheckout', component: rxcheckout }, { path: '*', redirect: '/home' }, {
    path: '/store',
    name: 'store',
    component: function component(_) {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 655));
    },
    redirect: '/store/home',
    children: [{ path: 'home', component: function component(_) {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 657));
      } }, { path: 'goods', component: function component(_) {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 656));
      } }]
  }, { path: '/article', name: 'article', component: article }, { path: '/custompage', name: 'custompage', component: custompage }, { path: '/promotion', name: 'promotion', component: promotion }, { path: '/preferential', name: 'preferential', component: preferential }]
}));

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_timeline_item_css__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_timeline_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_timeline_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_timeline_item__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_timeline_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_timeline_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_timeline_css__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_timeline_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_timeline_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_timeline__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_tag__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_carousel_item_css__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_carousel_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_carousel_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_carousel_item__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_carousel_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_carousel_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_carousel_css__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_chalk_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_carousel__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_image_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_image_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_image__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_col_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_col__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_row_css__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_row__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_tab_pane_css__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_tab_pane_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_chalk_tab_pane_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tab_pane__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tab_pane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tab_pane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_tabs_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_chalk_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tabs__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_radio__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_form_item_css__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_form_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_chalk_form_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_form_item__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_form_css__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_theme_chalk_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_form__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_breadcrumb_item_css__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_breadcrumb_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_theme_chalk_breadcrumb_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_breadcrumb_item__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_breadcrumb_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_breadcrumb_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_breadcrumb_css__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_breadcrumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_theme_chalk_breadcrumb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_breadcrumb__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_theme_chalk_upload_css__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_theme_chalk_upload_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_theme_chalk_upload_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_upload__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_element_ui_lib_theme_chalk_cascader_css__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_element_ui_lib_theme_chalk_cascader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_element_ui_lib_theme_chalk_cascader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_cascader__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_theme_chalk_option_css__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_option__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_element_ui_lib_theme_chalk_select_css__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_select__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_dialog__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_element_ui_lib_theme_chalk_input_css__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui_lib_input__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_element_ui_lib_table_column__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_element_ui_lib_theme_chalk_table_css__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_table__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_element_ui_lib_theme_chalk_step_css__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_element_ui_lib_theme_chalk_step_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_element_ui_lib_theme_chalk_step_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_element_ui_lib_step__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_element_ui_lib_theme_chalk_steps_css__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_element_ui_lib_theme_chalk_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_element_ui_lib_theme_chalk_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_element_ui_lib_steps__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_element_ui_lib_theme_chalk_autocomplete_css__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_element_ui_lib_theme_chalk_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_element_ui_lib_theme_chalk_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_autocomplete__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_element_ui_lib_theme_chalk_icon_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_element_ui_lib_theme_chalk_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_element_ui_lib_theme_chalk_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_element_ui_lib_icon__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_element_ui_lib_checkbox__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_element_ui_lib_pagination__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_element_ui_lib_button__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__App__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__router__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__store___ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_vue_lazyload__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_vue_infinite_scroll__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_vue_cookie__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_babel_polyfill__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__filter__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__config_basics_config__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__config_basics_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__config_basics_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_vue_content_placeholders__ = __webpack_require__(623);
















































































// import { userInfo } from './api'

// import { getStore } from '/utils/storage'

__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_79_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_68_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_65_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_63_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_61_element_ui_lib_icon___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_59_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_57_element_ui_lib_steps___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_55_element_ui_lib_step___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_53_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_51_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_49_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_cascader___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_breadcrumb___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_breadcrumb_item___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tab_pane___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_image___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_carousel_item___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_tag___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_timeline___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_timeline_item___default.a);

__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default.a.directive);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a;
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_74_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_75_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_73_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  error: '/static/images/lazy.jpg',
  loading: '/static/images/load.gif',
  attempt: 1
});
__WEBPACK_IMPORTED_MODULE_69_vue__["default"].config.productionTip = false;
// const whiteList = ['/main', '/goods', '/login', '/register', '/goodsDetails', '/search', '/refreshsearch', '/refreshgoods'] // 不需要登录的页面
// router.beforeEach(function (to, from, next) {
//   if (to.path === '/login' || to.path === '/home' || to.path === '/') {
//     next()
//     return
//   }
//   userInfo().then(({data}) => {
//     store.commit('RECORD_USERINFO', {info: data})
//     console.log('router beforeEach to-->', to)
//     next()
//   }).catch(err => {
//     console.log('router.beforeEach, userInfo', err, err.response)
//     if (err.response.status === 401) {
//       if (whiteList.indexOf(to.path) !== -1) { // 白名单
//         console.log('白名单')
//         next()
//       } else {
//         console.log('非白名单')
//         next({ path: '/login' })
//       }
//     }
//   })
// })
/* eslint-disable */

var ua = window.navigator.userAgent.toLowerCase();
var Agents = ['android', 'iphone', 'webos', 'blackberry', 'symbianos', 'windows phone', 'ipad', 'ipod'];

// 获取当前域名
var loca = window.location;
// 是否有www可以替换
var isRepalce = loca.host.indexOf('www');
// 是否包含wap
var isWap = loca.host.indexOf('wap.');
// 替换www为wap
var wap = loca.protocol + '//';
if (isRepalce !== -1) {
  wap = loca.href.replace('www', 'wap');
} else {
  wap += 'wap.' + loca.host + loca.pathname;
}
console.log('process.env.WAP_DOMAIN', __WEBPACK_IMPORTED_MODULE_78__config_basics_config___default.a.WAP_DOMAIN);
for (var i = 0; i < Agents.length; i++) {
  if (ua.indexOf(Agents[i]) > 0 && isWap === -1) {
    window.location.href = __WEBPACK_IMPORTED_MODULE_78__config_basics_config___default.a.WAP_DOMAIN;
    break;
  }
}

new __WEBPACK_IMPORTED_MODULE_69_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_72__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_71__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_70__App___default.a);
  },
  data: {
    eventHub: new __WEBPACK_IMPORTED_MODULE_69_vue__["default"]()
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return userLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userLogoutStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getCodeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return userCodeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getRegisterParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return retrieve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getimageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSmsCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getQiniuToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return uploadAvatar; });
/* unused harmony export updateheadimage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getAgreement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getArticle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCodeGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCodeShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDesignTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateDesignEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public__ = __webpack_require__(237);

/**
 * fetch( 链接, 参数, 方法, 是否需要token )
**/

// 登录
var userLogin = function userLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/login', params, 'POST');
};
// 注销登录
var userLogout = function userLogout(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/logout', params, 'POST', true);
};
// 注销登录
var userLogoutStatus = function userLogoutStatus(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/logout/status', params, 'GET');
};
// 获取登录二维码
var getCodeLogin = function getCodeLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/pcloginqrcode', params, 'GET');
};
// 二维码登录
var userCodeLogin = function userCodeLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/oauth/login/valid', params, 'GET');
};
// 获取注册参数
var getRegisterParam = function getRegisterParam(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/setting', params, 'GET');
};
// 注册账号
var register = function register(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member', params, 'POST');
};
// 找回密码
var retrieve = function retrieve(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/reset/password', params, 'POST');
};
// 获取验证码图片
var getimageData = function getimageData(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/image/code', params, 'GET');
};
// 获取手机验证码
var getSmsCode = function getSmsCode(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/sms/code', params, 'GET');
};
// 获取七牛token
var getQiniuToken = function getQiniuToken(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/espier/image_upload_token', params, 'GET');
};
// 用户信息
var userInfo = function userInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member', params, 'GET', true);
};
// 上传图片
var uploadAvatar = function uploadAvatar(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member', params, 'PUT', true);
};
// 修改头像
var updateheadimage = function updateheadimage(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('/member/updateheadimage', params, 'POST', true);
};
// // 首页接口
// export const productHome = (params) => {
//   return http.fetch('/goods/home', params, 'GET')
// }
// 首页接口
var getCateList = function getCateList(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/goods/category', params, 'GET');
};
// // 推荐板块
// export const recommend = (params) => {
//   return http.fetch('/goods/recommend', params, 'GET')
// }
// // 极验验证码
// export const geetest = (params) => {
//   return http.fetch('/member/geetestInit?t=' + (new Date()).getTime(), params, 'GET')
// }
// logo
var getLogo = function getLogo(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/company/setting', params, 'GET');
};
// 优惠券列表
var getCoupon = function getCoupon(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/user/newGetCardList', params, 'GET', true);
};
// 获取注册协议
var getAgreement = function getAgreement(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/agreement', params, 'GET');
};
// 获取文章
var getArticle = function getArticle(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/article/management/' + params.article_id, params, 'GET');
};
// 获取商品详情二维码
var getCodeGoods = function getCodeGoods(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/pcqrcode', params, 'GET');
};
// 获取店铺二维码
var getCodeShop = function getCodeShop(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/pcqrcode', params, 'GET');
};
// 获取用户是否有设计师标签
var getDesignTags = function getDesignTags(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/design/token', params, 'GET', true);
};
// 设计圈绑定邮箱
var updateDesignEmail = function updateDesignEmail(params) {
  return __WEBPACK_IMPORTED_MODULE_1__public__["a" /* default */].fetch('api/h5app/wxapp/member/design/bind?design_email=' + params.email, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params.email), 'POST', true);
};

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);








var baseUrl = 'https://b.kukahome.com/';
if (true) {
  baseUrl = "https://b.kukahome.com/".indexOf('http') !== -1 ? "https://b.kukahome.com/" : window.location.origin;
}
var axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: baseUrl,
  data: {},
  headers: { 'Content-Type': 'application/json' }
});

// axios.defaults.timeout = 10000
// 不需要跳转登录的白名单
var whiteList = [{ url: baseUrl + 'api/h5app/wxapp/member/collect/item', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/member', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/cart', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/cartcount', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/goods/items', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/member/collect/distribution', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/member/collect/item', method: 'get' }, { url: baseUrl + 'api/h5app/wxapp/cartcount', method: 'get' }];

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  switch (error.response.status) {
    case 401:
      var flag = false;
      whiteList.map(function (v) {
        var _error$response$confi = error.response.config,
            url = _error$response$confi.url,
            method = _error$response$confi.method;

        v.url === url && v.method === method && (flag = true);
      });
      if (flag) {
        console.log('axios.interceptor白名单 url---> ', error.response.config.url);break;
      }
      console.log('continue', error.response.config);
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/login' });
      break;
    default:
      console.log('操作失败', error.response);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$message.error({
        message: error.response.data.error ? error.response.data.error.message : '操作失败! 请稍后重试!'
      });
      break;
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
});
var fetch = function fetch() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
  var token = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var special = arguments[4];

  var params = {
    url: url,
    data: data,
    method: type,
    headers: {}
  };

  if (token) {
    params.headers['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["a" /* getStore */])('token');
  }

  if (type === 'GET') {
    params.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, data, { company_id: '2' });
    // params.params = Object.assign({}, data, {})
  }
  // params.data = Object.assign({}, params.data, {})
  params.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params.data, { company_id: '2' });

  if (type === 'DELETE' && special === 'special') {
    // 取消收藏
    params.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    params.data = __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(params.data);
  }
  // console.log('request params', params)
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    axios(params).then(function (res) {
      // axios.request(params).then(res => {
      resolve(res.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};
console.warn('baseUrl', baseUrl);
/* harmony default export */ __webpack_exports__["a"] = ({ fetch: fetch, baseUrl: baseUrl });

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports =  {
  WAP_DOMAIN: 'https://kmalltest.kukahome.com/',
}


/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_index__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_storage__ = __webpack_require__(113);



//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapMutations */])(['GET_USERINFO', 'LOG_OUT']), {
    _userLogoutStatus: function _userLogoutStatus() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userInfo, _JSON$parse, memberInfo, user_id, _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_storage__["a" /* getStore */])('userInfo');

                if (userInfo) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _JSON$parse = JSON.parse(userInfo), memberInfo = _JSON$parse.memberInfo;
                user_id = memberInfo.user_id;
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api_index__["a" /* userLogoutStatus */])({ user_id: user_id });

              case 7:
                _ref = _context.sent;
                data = _ref.data;

                if (data.status) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:

                localStorage.clear();
                _this.LOG_OUT(false);

                setTimeout(function () {
                  _this.$router.replace({ path: "/home" });
                }, 0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  created: function created() {
    this._userLogoutStatus();
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);

// Vue.filter('price', function (value) {
//   // if (!value) return ''
//   return (Number(value) / 100).toFixed(2)
// })
// Vue.filter('currency', (value, currency = '￥', decimals = 2) => {
//   if(value){
//     return value.toLocaleString()
//   }else{
//     return 0;
//   }
// }
var digitsRE = /(\d{3})(?=\d)/g;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('price', function (value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '¥';
  var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  // console.log('filter', value)
  value = parseFloat(value) / 100;
  if (!isFinite(value) || !value && value !== 0) return '';
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('telephone', function (value) {
  if (!value) {
    return false;
  }
  return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(299);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  receiveInCart: false, // 是否进入购物车
  showCart: false, // 是否显示购物车
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  breadcrumb: [], // 面包屑
  storeTemplate: null, // 店铺装修的信息
  cartCount: 0
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOG_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECORD_STORETEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_CARTCOUNT; });
var INIT_BUYCART = 'INIT_BUYCART';
var UPDATE_BUYCART = 'UPDATE_BUYCART';
var ADD_CART = 'ADD_CART';
var LOG_OUT = 'LOG_OUT';
var RECORD_USERINFO = 'RECORD_USERINFO';
var GET_USERINFO = 'GET_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';
var UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';
var RECORD_STORETEMPLATE = 'RECORD_STORETEMPLATE';
var UPDATE_CARTCOUNT = 'UPDATE_CARTCOUNT';

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage__ = __webpack_require__(113);


var _INIT_BUYCART$UPDATE_;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$UPDATE_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* UPDATE_BUYCART */], function (state, cartList) {
  state.cartList = cartList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ADD_CART */], function (state, _ref) {
  var itemId = _ref.itemId,
      price = _ref.price,
      itemName = _ref.itemName,
      pics = _ref.pics,
      _ref$num = _ref.num,
      num = _ref$num === undefined ? 1 : _ref$num;

  var cart = state.cartList; // 购物车
  var flag = true;
  var goods = {
    itemId: itemId,
    price: price,
    itemName: itemName,
    pics: pics
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.itemId === itemId) {
        if (item.num >= 0) {
          flag = false;
          item.num += num;
        }
      }
    });
  }
  if (!cart.length || flag) {
    goods.num = num;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  state.showCart = showCart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* REDUCE_CART */], function (state, _ref4) {
  var itemId = _ref4.itemId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.itemId === itemId) {
      if (item.num > 1) {
        item.num--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* EDIT_CART */], function (state, _ref5) {
  var itemId = _ref5.itemId,
      num = _ref5.num,
      checked = _ref5.checked,
      type = _ref5.type;

  var cart = state.cartList;
  if (type === 'checkAll') {
    cart.forEach(function (item) {
      item.is_checked = true;
    });
    state.cartList = cart;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
    return;
  }
  if (type === 'cancelCheckAll') {
    cart.forEach(function (item) {
      item.is_checked = false;
    });
    state.cartList = cart;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
    return;
  }
  cart.forEach(function (item) {
    if (item.item_id === itemId) {
      item.num = num;
      item.is_checked = checked;
    }
  });
  state.cartList = cart;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* setStore */])('userInfo', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* RECORD_STORETEMPLATE */], function (state, info) {
  console.log('RECORD_STORETEMPLATE', info);
  state.storeTemplate = info;
  // setStore('storeTemplate', info)
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* GET_USERINFO */], function (state) {
  var userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* getStore */])('userInfo');
  if (userInfo) {
    state.userInfo = JSON.parse(userInfo);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* LOG_OUT */], function (state, info) {
  state.login = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* UPDATE_BREADCRUMB */], function (state, info) {
  state.breadcrumb = info;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$UPDATE_, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* UPDATE_CARTCOUNT */], function (state, info) {
  state.cartCount = info;
}), _INIT_BUYCART$UPDATE_);

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(234)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
module.exports = __webpack_require__(233);


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/element-icons.732389d.ttf";

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/element-icons.535877f.woff";

/***/ })

},[631]);


// WEBPACK FOOTER //
// static/js/app.f6d198c0d323db4455ae.js